import { Capacitor, CapacitorHttp } from '@capacitor/core';

export const PRODUCTION_ORIGIN = 'https://stone-harbor-beach-day-app.com';
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();

export function apiUrl(path: string): string {
  if (!path.startsWith('/api/')) throw new Error('Invalid API path');
  return isNativeApp() ? `${PRODUCTION_ORIGIN}${path}` : path;
}

export function reactionSocketUrl(): string {
  if (isNativeApp()) return `${PRODUCTION_ORIGIN.replace('https:', 'wss:')}/ws`;
  const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${scheme}://${window.location.host}/ws`;
}

export async function getApiJson<T>(path: string, fresh = false): Promise<T> {
  if (isNativeApp()) {
    // The native HTTP stack reaches the same geofenced API without weakening CORS.
    const response = await CapacitorHttp.get({
      url: apiUrl(path), responseType: 'json', disableRedirects: true,
      connectTimeout: 10_000, readTimeout: 20_000,
      headers: fresh ? { 'Cache-Control': 'no-cache' } : {},
    });
    if (response.status < 200 || response.status >= 300) {
      throw new Error(`Request failed: ${response.status}`);
    }
    return response.data as T;
  }
  const response = await fetch(apiUrl(path), fresh ? { cache: 'no-store' } : undefined);
  if (!response.ok) throw new Error(`Request failed: ${response.status}`);
  return response.json();
}

export async function postNativeApiJson<T>(path: string, body: unknown): Promise<T> {
  if (!isNativeApp()) throw new Error('Native notification registration requires the native app');
  const response = await CapacitorHttp.post({
    url: apiUrl(path), data: body, responseType: 'json', disableRedirects: true,
    connectTimeout: 10_000, readTimeout: 20_000, headers: { 'Content-Type': 'application/json' },
  });
  if (response.status < 200 || response.status >= 300) throw new Error(`Alert registration failed (${response.status})`);
  return response.data as T;
}
